import { type SupportedLocale, supportedLocales } from "@site-types/site"

export const defaultLocale = "ja" satisfies SupportedLocale

export function isSupportedLocale(value: string | undefined): value is SupportedLocale {
  return supportedLocales.includes(value as SupportedLocale)
}

export function getLangFromPath(
  pathname: string = typeof location === "undefined" ? "/" : location.pathname
): SupportedLocale {
  const [, lang] = pathname.split("/")
  return isSupportedLocale(lang) ? lang : defaultLocale
}
